import { IParamsGetDegree } from 'app/api/degree/model'

export const DegreeKeys = {
  allDegrees: ['Degrees'] as const,
  listDegrees: () => [...DegreeKeys.allDegrees, 'listDegrees'] as const,
  listDegree: (filter?: IParamsGetDegree) =>
    [...DegreeKeys.listDegrees(), { filter }] as const,
}
